const LOCAL_HOSTS = new Set(["localhost", "127.0.0.1", "::1"]);

function isIp(hostname: string): boolean {
  return /^[0-9.]+$/.test(hostname);
}

export function normalizePublicUrl(value?: string | null): string | undefined {
  if (!value) {
    return undefined;
  }

  try {
    const parsed = new URL(value);

    if (
      parsed.protocol === "http:" &&
      !LOCAL_HOSTS.has(parsed.hostname) &&
      !isIp(parsed.hostname)
    ) {
      parsed.protocol = "https:";
    }

    return parsed.toString().replace(/\/$/, "");
  } catch {
    return value;
  }
}

export const PLATFORM_API_URL =
  normalizePublicUrl(process.env.NEXT_PUBLIC_PLATFORM_API_URL) ||
  "http://localhost:8001";

// Public agent-orchestrator URL — the host external clients hit for the
// OpenAI-compatible `/v1/chat/completions` endpoint. Local dev defaults
// to the docker-compose port mapping (`docker-compose.local.yml` exposes
// orchestrator port 8200 → host 8200). Production should set
// `NEXT_PUBLIC_AGENT_ORCHESTRATOR_URL` explicitly.
export const AGENT_ORCHESTRATOR_URL =
  normalizePublicUrl(process.env.NEXT_PUBLIC_AGENT_ORCHESTRATOR_URL) ||
  "http://localhost:8200";